angular
  .module 'bookAndPay'
  .directive 'integrapayForm', () ->
    restrict: 'EA'
    template: require('templates/book_and_pay/integrapay_form.html.slim')
    scope:
      cart: '='
      months: '='
      years: '='
      currency: '='
      expired: '='
      toNewCart: '&'
    controller: ($scope, $timeout) ->
      $scope.card = {}
      $scope.pageParams = {}

      loadIntegrapayScript = ->
        return if document.querySelectorAll('#realtime_js_url').length
        script = document.createElement('script')
        script.id = 'realtime_js_url'
        script.type = 'text/javascript'
        script.src = $scope.cart.realtime_js_url
        document.body.appendChild(script)

      $scope.getActionUrl = ->
        "#{window.location.origin}/websites/#{window.DATA.domain}/book_and_pay/\
          carts/#{$scope.cart.cart_uuid}/handle_hosted_payment_result"

      $scope.onCardChange = ->
        $scope.card.number = $scope.card.number?.replace(/[^0-9]/g, '')

      $scope.onSubmit = ->
        return if $scope.pageParams.isLoading || $scope.expired

        $scope.pageParams.isLoading = true
        $timeout () ->
          if document.querySelectorAll("[data-integrapay='Errors']")[0].innerText
            $scope.pageParams.isLoading = false
        , 300

      loadIntegrapayScript()
